import React from 'react';
import { Path } from 'app/const/Path';
import HelpIcon from '@material-ui/icons/Help';
import InfoIcon from '@material-ui/icons/Info';
import MailIcon from '@material-ui/icons/Mail';
import ExploreIcon from '@material-ui/icons/Explore';
import BookmarkIcon from '@material-ui/icons/Bookmark';
import TableChartIcon from '@material-ui/icons/TableChart';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import MailOutlinedIcon from '@material-ui/icons/MailOutlined';
import BookmarkBorderIcon from '@material-ui/icons/BookmarkBorder';
import ExploreOutlinedIcon from '@material-ui/icons/ExploreOutlined';
import TableChartOutlinedIcon from '@material-ui/icons/TableChartOutlined';
import HelpOutlineOutlinedIcon from '@material-ui/icons/HelpOutlineOutlined';

export const KNOWLEDGE_HUB_FREE =
  'https://sites.google.com/aida.tools/aidafaqknowledgehub/aida-explorer-knowledge-hub';
export const KNOWLEDGE_HUB_PAID =
  'https://sites.google.com/aida.tools/aidadataservicesknowledgehub/aida-frequently-asked-questions';

const KnowledgeHubOutlinedIcon = () => (
  <svg width="24" height="25" viewBox="0 0 24 25">
    <g clipPath="url(#clip0_471_7808)">
      <path
        fill="#2E4063"
        d="M6 23.0458C5.16667 23.0458 4.45833 22.7541 3.875 22.1708C3.29167 21.5874 3 20.8791 3 20.0458C3 19.2124 3.29167 18.5041 3.875 17.9208C4.45833 17.3374 5.16667 17.0458 6 17.0458C6.23333 17.0458 6.45 17.0708 6.65 17.1208C6.85 17.1708 7.04167 17.2374 7.225 17.3208L8.65 15.5458C8.18333 15.0291 7.85833 14.4458 7.675 13.7958C7.49167 13.1458 7.45 12.4958 7.55 11.8458L5.525 11.1708C5.24167 11.5874 4.88333 11.9208 4.45 12.1708C4.01667 12.4208 3.53333 12.5458 3 12.5458C2.16667 12.5458 1.45833 12.2541 0.875 11.6708C0.291667 11.0874 0 10.3791 0 9.54578C0 8.71244 0.291667 8.00411 0.875 7.42078C1.45833 6.83744 2.16667 6.54578 3 6.54578C3.83333 6.54578 4.54167 6.83744 5.125 7.42078C5.70833 8.00411 6 8.71244 6 9.54578V9.74578L8.025 10.4458C8.35833 9.84578 8.80433 9.33744 9.363 8.92078C9.921 8.50411 10.55 8.23744 11.25 8.12078V5.94578C10.6 5.76244 10.0623 5.40811 9.637 4.88278C9.21233 4.35811 9 3.74578 9 3.04578C9 2.21244 9.29167 1.50411 9.875 0.920776C10.4583 0.337443 11.1667 0.0457764 12 0.0457764C12.8333 0.0457764 13.5417 0.337443 14.125 0.920776C14.7083 1.50411 15 2.21244 15 3.04578C15 3.74578 14.7833 4.35811 14.35 4.88278C13.9167 5.40811 13.3833 5.76244 12.75 5.94578V8.12078C13.45 8.23744 14.0793 8.50411 14.638 8.92078C15.196 9.33744 15.6417 9.84578 15.975 10.4458L18 9.74578V9.54578C18 8.71244 18.2917 8.00411 18.875 7.42078C19.4583 6.83744 20.1667 6.54578 21 6.54578C21.8333 6.54578 22.5417 6.83744 23.125 7.42078C23.7083 8.00411 24 8.71244 24 9.54578C24 10.3791 23.7083 11.0874 23.125 11.6708C22.5417 12.2541 21.8333 12.5458 21 12.5458C20.4667 12.5458 19.9793 12.4208 19.538 12.1708C19.096 11.9208 18.7417 11.5874 18.475 11.1708L16.45 11.8458C16.55 12.4958 16.5083 13.1414 16.325 13.7828C16.1417 14.4248 15.8167 15.0124 15.35 15.5458L16.775 17.2958C16.9583 17.2124 17.15 17.1498 17.35 17.1078C17.55 17.0664 17.7667 17.0458 18 17.0458C18.8333 17.0458 19.5417 17.3374 20.125 17.9208C20.7083 18.5041 21 19.2124 21 20.0458C21 20.8791 20.7083 21.5874 20.125 22.1708C19.5417 22.7541 18.8333 23.0458 18 23.0458C17.1667 23.0458 16.4583 22.7541 15.875 22.1708C15.2917 21.5874 15 20.8791 15 20.0458C15 19.7124 15.0543 19.3918 15.163 19.0838C15.271 18.7751 15.4167 18.4958 15.6 18.2458L14.175 16.4708C13.4917 16.8541 12.7627 17.0458 11.988 17.0458C11.2127 17.0458 10.4833 16.8541 9.8 16.4708L8.4 18.2458C8.58333 18.4958 8.72933 18.7751 8.838 19.0838C8.946 19.3918 9 19.7124 9 20.0458C9 20.8791 8.70833 21.5874 8.125 22.1708C7.54167 22.7541 6.83333 23.0458 6 23.0458ZM3 10.5458C3.28333 10.5458 3.521 10.4498 3.713 10.2578C3.90433 10.0664 4 9.82911 4 9.54578C4 9.26244 3.90433 9.02478 3.713 8.83278C3.521 8.64144 3.28333 8.54578 3 8.54578C2.71667 8.54578 2.47933 8.64144 2.288 8.83278C2.096 9.02478 2 9.26244 2 9.54578C2 9.82911 2.096 10.0664 2.288 10.2578C2.47933 10.4498 2.71667 10.5458 3 10.5458ZM6 21.0458C6.28333 21.0458 6.521 20.9498 6.713 20.7578C6.90433 20.5664 7 20.3291 7 20.0458C7 19.7624 6.90433 19.5251 6.713 19.3338C6.521 19.1418 6.28333 19.0458 6 19.0458C5.71667 19.0458 5.479 19.1418 5.287 19.3338C5.09567 19.5251 5 19.7624 5 20.0458C5 20.3291 5.09567 20.5664 5.287 20.7578C5.479 20.9498 5.71667 21.0458 6 21.0458ZM12 4.04578C12.2833 4.04578 12.521 3.94978 12.713 3.75778C12.9043 3.56644 13 3.32911 13 3.04578C13 2.76244 12.9043 2.52478 12.713 2.33278C12.521 2.14144 12.2833 2.04578 12 2.04578C11.7167 2.04578 11.4793 2.14144 11.288 2.33278C11.096 2.52478 11 2.76244 11 3.04578C11 3.32911 11.096 3.56644 11.288 3.75778C11.4793 3.94978 11.7167 4.04578 12 4.04578ZM12 15.0458C12.7 15.0458 13.2917 14.8041 13.775 14.3208C14.2583 13.8374 14.5 13.2458 14.5 12.5458C14.5 11.8458 14.2583 11.2541 13.775 10.7708C13.2917 10.2874 12.7 10.0458 12 10.0458C11.3 10.0458 10.7083 10.2874 10.225 10.7708C9.74167 11.2541 9.5 11.8458 9.5 12.5458C9.5 13.2458 9.74167 13.8374 10.225 14.3208C10.7083 14.8041 11.3 15.0458 12 15.0458ZM18 21.0458C18.2833 21.0458 18.5207 20.9498 18.712 20.7578C18.904 20.5664 19 20.3291 19 20.0458C19 19.7624 18.904 19.5251 18.712 19.3338C18.5207 19.1418 18.2833 19.0458 18 19.0458C17.7167 19.0458 17.4793 19.1418 17.288 19.3338C17.096 19.5251 17 19.7624 17 20.0458C17 20.3291 17.096 20.5664 17.288 20.7578C17.4793 20.9498 17.7167 21.0458 18 21.0458ZM21 10.5458C21.2833 10.5458 21.5207 10.4498 21.712 10.2578C21.904 10.0664 22 9.82911 22 9.54578C22 9.26244 21.904 9.02478 21.712 8.83278C21.5207 8.64144 21.2833 8.54578 21 8.54578C20.7167 8.54578 20.4793 8.64144 20.288 8.83278C20.096 9.02478 20 9.26244 20 9.54578C20 9.82911 20.096 10.0664 20.288 10.2578C20.4793 10.4498 20.7167 10.5458 21 10.5458Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_471_7808">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.0457764)"
        />
      </clipPath>
    </defs>
  </svg>
);

export interface GlobalNavItemProps {
  label: string;
  path: string;
  icon: JSX.Element;
  iconActive: JSX.Element;
  needsAuth?: boolean;
}

const GlobalNavItems: GlobalNavItemProps[] = [
  {
    label: 'Data Explorer',
    path: Path.home,
    icon: <ExploreOutlinedIcon fontSize="inherit" />,
    iconActive: <ExploreIcon fontSize="inherit" />,
  },
  {
    label: 'Data Management',
    path: Path.dataManagement.root,
    icon: <TableChartOutlinedIcon fontSize="inherit" />,
    iconActive: <TableChartIcon fontSize="inherit" />,
    needsAuth: true,
  },
  {
    label: 'Bookmarks',
    path: Path.bookmarks,
    icon: <BookmarkBorderIcon fontSize="inherit" />,
    iconActive: <BookmarkIcon fontSize="inherit" />,
    needsAuth: true,
  },
  {
    label: 'Knowledge Hub',
    path: Path.webshop.knowledgeHub,
    icon: <KnowledgeHubOutlinedIcon />,
    iconActive: <KnowledgeHubOutlinedIcon />,
  },
  {
    label: 'FAQs',
    path: Path.general.faq,
    icon: <HelpOutlineOutlinedIcon fontSize="inherit" />,
    iconActive: <HelpIcon fontSize="inherit" />,
  },
  {
    label: 'About',
    path: Path.general.about,
    icon: <InfoOutlinedIcon fontSize="inherit" />,
    iconActive: <InfoIcon fontSize="inherit" />,
  },
  {
    label: 'Contact',
    path: Path.general.contact,
    icon: <MailOutlinedIcon fontSize="inherit" />,
    iconActive: <MailIcon fontSize="inherit" />,
  },
];

export function getGlobalNavItems(paidUser: boolean): GlobalNavItemProps[] {
  const items = GlobalNavItems;
  if (paidUser) {
    items[3].path = KNOWLEDGE_HUB_PAID;
  } else {
    items[3].path = KNOWLEDGE_HUB_FREE;
  }
  return items;
}
